import React, { useEffect } from 'react'
import { DislikeFilled, DislikeOutlined, LikeFilled, LikeOutlined } from '@ant-design/icons'
import { useEditConversationMutation } from '../../../store/api/pubic.api'
import { useAppSelector } from '../../../hooks/appHook'
import './LikeDislikeMessageButtons.less'
import { MessageFeedback } from '../../../types/storage.type'
import useScrollToMessage from '../../../hooks/useScrollToMessage'
import { Button, Tooltip } from 'antd'

type IProps = {
  feedback: [MessageFeedback] | undefined
  messageId: string | number
  conversationId: string
  refetchConversation: () => void
}

const LikeDislikeMessageButtons = ({ feedback, messageId, conversationId, refetchConversation }: IProps) => {
  const [rateMessage, rateMessageResult] = useEditConversationMutation()
  const { user } = useAppSelector((state) => state.appState)

  const { saveMessageId, scrollToMessage } = useScrollToMessage()
  const myFeedback = feedback?.find((f) => f.userId === user.id)

  const onClick = (rating: 'like' | 'dislike') => {
    saveMessageId(String(messageId))
    rateMessage({
      id: conversationId,
      body: {
        messageFeedback: {
          messageId,
          rating,
        },
      },
    })
  }

  useEffect(() => {
    if (rateMessageResult.isSuccess) {
      refetchConversation()
      setTimeout(() => {
        scrollToMessage()
      }, 500)
    }
  }, [rateMessageResult.isSuccess])

  return (
    <>
      {myFeedback ? (
        myFeedback.rating === 'like' ? (
          <Tooltip title="Good response" placement="bottom">
            <Button type="text" icon={<LikeFilled />} className="checked-button-state" style={{ color: 'gray' }} />
          </Tooltip>
        ) : (
          <Tooltip title="Bad response" placement="bottom">
            <Button type="text" icon={<DislikeFilled />} className="checked-button-state" style={{ color: 'gray' }} />
          </Tooltip>
        )
      ) : (
        <>
          <Tooltip title="Good response" placement="bottom">
            <Button type="text" icon={<LikeOutlined />} onClick={() => onClick('like')} />
          </Tooltip>
          <Tooltip title="Bad response" placement="bottom">
            <Button type="text" icon={<DislikeOutlined />} onClick={() => onClick('dislike')} />
          </Tooltip>
        </>
      )}
    </>
  )
}

export default LikeDislikeMessageButtons
